import { useEffect, useState } from 'react';
import UserShowsPage from '../components/UserShowsPage';
import { Link, useParams } from '../util/router';
import { requireAuth } from '../util/auth';
import { getFollowingShowsDataByUser } from '../util/db';

function FollowingShowsPage() {
  const { userId } = useParams();
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getFollowingShowsDataByUser(userId)
      .then(setShows)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [userId]);

  return (
    <UserShowsPage
      userId={userId}
      heading="Following Shows"
      subtitle="On view now or opening within four weeks at venues you follow"
      shows={shows}
      loading={loading}
      source="following_shows"
      empty={
        <>
          No shows from followed venues right now. Follow galleries and institutions from{' '}
          <Link to="/search?type=venue" className="text-secondary-red underline">
            search
          </Link>{' '}
          to see their shows here.
        </>
      }
    />
  );
}

export default requireAuth(FollowingShowsPage);
